import { Button, Stack } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import React from "react";

import { deleteScopeDocument } from "api";

import { TrashIcon } from "assets";

import { DeleteDialog, SelectionCounter, useDialogControls } from "components";

import { useNotify } from "hooks";

import {
  useSetDefaultUploadDocumentEntriesSelection,
  useUserRole,
} from "recoils";

export const PopupActions: React.FunctionComponent<{
  refresh: any;
  rowSelection: any;
  setrowSelection: any;
}> = ({ refresh, rowSelection, setrowSelection }) => {
  const notify = useNotify();
  const userRole = useUserRole();
  const setDefaultSelection = useSetDefaultUploadDocumentEntriesSelection();
  const deleteDialogControls = useDialogControls();
  const { mutateAsync: deleteUploadedDocument } =
    useMutation(deleteScopeDocument);
  // const selected = useSelectedUploadDocumentEntries();

  const selected: any[] = [];

  selected.push(...Object.keys(rowSelection));

  const onDeleteClick = () => {
    Promise.allSettled(
      selected.map((id) =>
        deleteUploadedDocument(id, {
          onError: () =>
            notify.error(
              `Some error has happen while deleting documents: ${id}!`,
            ),
          onSuccess: () => {
            notify.success("Selected documents were deleted!");
            // const { refresh } = props;
            refresh();
            setrowSelection();
          },
        }),
      ),
    ).finally(() => {
      deleteDialogControls.close();
      setDefaultSelection();
    });
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <SelectionCounter selectedElements={selected.length} />

      <Button
        startIcon={<TrashIcon />}
        variant="outlined"
        disabled={selected.length === 0 || userRole.isAuditor}
        onClick={deleteDialogControls.open}
      >
        Delete
      </Button>

      <DeleteDialog
        isOpen={deleteDialogControls.isOpen}
        onCancel={deleteDialogControls.close}
        onDeleteClick={onDeleteClick}
        selectedCount={selected.length}
        target="document"
        title="Delete documents?"
      />
    </Stack>
  );
};
